import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import {
  DetailConsumableResponse,
  DetailsConsumableTransfer,
  UpdateDetailsConsumableRequest,
} from '../models/detailsConsumable';

/**
 * <p>
 * API endpoints that cover all details consumable related CRUD calls
 */
export const detailsConsumableApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchConsumableBook: builder.query<DetailConsumableResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-consumable/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}&`,
        ),
      }),
      providesTags: ['searchDetailsBook', 'SearchEquipment', 'SearchDetails'],
    }),
    UnitConsumable: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-consumable/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    undoUnionConsumable: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-consumable/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    updateConsumable: builder.mutation<void, UpdateDetailsConsumableRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-consumable/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    consumableTransfer: builder.mutation<void, DetailsConsumableTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-consumable/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchConsumableBookQuery,
  useUnitConsumableMutation,
  useUndoUnionConsumableMutation,
  useUpdateConsumableMutation,
  useConsumableTransferMutation,
} = detailsConsumableApi;
